// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3yPZO","container":"styles_container__3tYdI","title":"styles_title__aSCIV","wrapper":"styles_wrapper__1FlxZ","answer":"styles_answer__32s3l"};